import { ICellRendererParams } from 'ag-grid-enterprise';
import { Order, OrderType, Side } from '@protos/v2/order';
import darkTheme from '@shared/themes/darkTheme';
import { OrderState } from '@protos/trading';
import styled from '@emotion/styled';
import { streamV2 } from '@services/context';
import { useState } from 'react';

export const AmountCellRenderer = (params: ICellRendererParams<Order>) => {
  const { data } = params;
  if (!data) {
    return <></>;
  }

  const { amount, executed_amount, side } = data;

  const toFill = Number(amount);
  const filled = Number(executed_amount);

  if (isNaN(toFill) || isNaN(filled) || toFill === 0) {
    return <div>{amount}</div>;
  }

  const filledRatio = Number(executed_amount) / Number(amount);
  const barWidth = filledRatio * 100 + '%';
  const barColour = side === Side.BUY ? darkTheme.palette.background.buyHover : darkTheme.palette.background.sellHover;
  const backgroundColour = side === Side.BUY ? darkTheme.palette.background.buyDark : darkTheme.palette.background.sellDark;
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative', background: backgroundColour }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: barWidth, height: '100%', backgroundColor: barColour, zIndex: 1 }}></div>

      <div style={{ zIndex: 5, position: 'absolute', top: -1, left: 0, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: '10%' }} />
        <div style={{ fontWeight: 'bold' }}>{side.toUpperCase()} </div>

        <div style={{ textAlign: 'right', flexGrow: 1 }}>
          {executed_amount || 0} / {amount}
        </div>
        <div style={{ width: '10%' }} />
      </div>
    </div>
  );
};

const SimpleButton = (props: React.PropsWithChildren & { onClick: () => void }) => {
  return <div {...props}>{props.children}</div>;
};

const StyledSimpleButton = styled(SimpleButton)(() => ({
  cursor: 'pointer',
  background: 'hsl(157, 60%, 20%)',
  width: '100%',
  height: '100%',
  padding: 0,
  lineHeight: '1.7em',
  '&:hover': {
    background: 'hsla(7, 60%, 40%, 1.00)',
  },
  transition: 'all 0.2s ease',
  textTransform: 'uppercase',
}));

export const OrderTrackerActionCellRenderer = (params: ICellRendererParams<Order>) => {
  const { data } = params;
  if (!data) {
    return <></>;
  }

  const { id, order_type, order_state } = data;
  const isLimit = order_type === OrderType.LIMIT;
  const canCancel = [OrderState.PENDING_CREATED, OrderState.CREATED, OrderState.NEW, OrderState.PARTIALLY_FILLED].includes(order_state);

  const [hasClicked, setHasClicked] = useState<boolean>(false);

  const onClick = async () => {
    streamV2.cancelOtcQuoteOrder(id);
    setHasClicked(true);
  };

  if (canCancel && isLimit) {
    if (hasClicked) return <>CANCELLING...</>;

    return (
      <StyledSimpleButton theme={darkTheme} onClick={onClick}>
        {'Cancel'}
      </StyledSimpleButton>
    );
  }
  return <></>;
};
